import { render } from "./CurrentChapter.vue?vue&type=template&id=44f8eeed"
import script from "./CurrentChapter.vue?vue&type=script&lang=js"
export * from "./CurrentChapter.vue?vue&type=script&lang=js"
script.render = render

export default script